import { z } from 'zod';

import { stringToUuidArray } from '../codecs';

export type PhasesQuery = z.output<typeof phasesQuerySchema>;
export type PhasesQueryDTO = z.input<typeof phasesQuerySchema>;

export const phasesQuerySchema = z.object({
  sessionIds: stringToUuidArray,
});
